export const calculateMultiplicationInside = (total, splitBy) => {
    return Math.ceil(total / splitBy);
};



// WEBPACK FOOTER //
// ./app/web/src/helpers/Math.js